import { render, staticRenderFns } from "./ProgressSummary.vue?vue&type=template&id=6baf1622&"
import script from "./ProgressSummary.vue?vue&type=script&lang=js&"
export * from "./ProgressSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProgressSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/vigzero/vig-zero-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6baf1622')) {
      api.createRecord('6baf1622', component.options)
    } else {
      api.reload('6baf1622', component.options)
    }
    module.hot.accept("./ProgressSummary.vue?vue&type=template&id=6baf1622&", function () {
      api.rerender('6baf1622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProgressSummary.vue"
export default component.exports